import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, of, ReplaySubject} from "rxjs";
import {ReceivablesTransfer} from "../../../../shared/interface/receivables-transfer";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {RegionalService} from "../../../../shared/services/regional.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {validIban} from "../../../../shared/validator/iban-validator";
import {ReceivablesTransferService} from "../../../../shared/services/receivables-transfer.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Uuid} from "../../../../shared/interface/response/uuid";

@Component({
  selector: 'app-transfer-add',
  templateUrl: './transfer-add.component.html',
  styleUrls: ['./transfer-add.component.scss']
})
export class TransferAddComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() receivablesTransferObject?: ReceivablesTransfer;
  @Input() receivablesTransfer?: Observable<ReceivablesTransfer>;
  @Output() closeModification = new EventEmitter<any>();

  receivablesTransferForm: FormGroup;
  formErrors: any = {};
  processingRequest = false;
  formValid = false;
  transferAmountControl: FormControl;
  accountNumberControl: FormControl;
  transferTitleControl: FormControl;
  nameControl: FormControl;
  noteControl: FormControl;

  constructor(
    private receivablesTransferService: ReceivablesTransferService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.receivablesTransferForm = this.fb.group({
      transferAmount: this.transferAmountControl = fb.control('', [Validators.required]),
      accountNumber: this.accountNumberControl = fb.control('', [Validators.required,  validIban()]),
      transferTitle: this.transferTitleControl = fb.control('', [Validators.required]),
      name: this.nameControl = fb.control('', [Validators.required]),
      note: this.noteControl = fb.control(''),
    });
  }

  ngOnInit(): void {
    this.receivablesTransferForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.formValid = this.receivablesTransferForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (!this.receivablesTransferForm.valid) {
      this.receivablesTransferForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.receivablesTransferService.sendForm(this.receivablesTransferForm.getRawValue(), this.receivablesTransferObject ? this.receivablesTransferObject.uuid : null
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open(this.receivablesTransferObject ? 'Pomyślnie zaktualizowano przelew' : 'Pomyślnie utworzono przelew', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        if (this.receivablesTransfer) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/naleznosci/przelewy/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.receivablesTransferForm, this.formErrors);
        }
      });
  }

  cancel(): void {
    if (!this.receivablesTransferObject) {
      this.router.navigate(['/naleznosci/przelewy']);
    } else {
      this.closeModification.emit();
    }
  }


  initialize(receivablesTransfer: ReceivablesTransfer): void {
    of(receivablesTransfer)
      .pipe(
        delay(0),
        tap(() => {
          this.receivablesTransferForm.reset({
            transferAmount: receivablesTransfer.transferAmount,
            accountNumber: receivablesTransfer.accountNumber,
            transferTitle: receivablesTransfer.transferTitle,
            name: receivablesTransfer.name,
            note: receivablesTransfer.note,
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }
}
